export type { CounterProps } from "./Counter";
export { Counter } from "./Counter";
